<template>
    <div>
      <div class="details-body">
        <HeadDetailsGama :titleHead="'Lista de Despesa'" :buttonbackCustom="true" :buttontemplate="true">
            <template #button-edit>
                  <!-- Etapa TECNICO (status 9): Aprovar abre modal p/ escolher coordenador (lote). ADMIN aprova em qualquer etapa. -->
                  <div class="buttonaprova" v-if="(hasRole(roles.ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.RW_REAL_ESTA_ADMIN)) && allStatus(9)">
                      <button class="btn-reprovar" @click="disaApprove"><i class="fas fa-thumbs-down"></i> Reprovar</button>
                      <button class="btn-aprovar" @click="abrirModalTecnicoLote"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                  </div>
                  <!-- Etapa COORDENADOR (status 1) / TRANSPORTE (status 2): aprovar/reprovar em lote -->
                  <div class="buttonaprova" v-if="podeAprovarEtapa">
                      <button class="btn-reprovar" @click="disaApprove"><i class="fas fa-thumbs-down"></i> Reprovar</button>
                      <button class="btn-aprovar" @click="approve"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                  </div>
                  <!-- Etapa DIRETORIA (status 3): revisar (retorna p/ Transportes) -->
                  <div class="buttonaprova" v-if="(hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) && someStatus(3)">
                      <button class="btn-revisar" @click="openReviewModal"><i class="fas fa-undo-alt"></i> Revisar</button>
                  </div>
            </template>
        </HeadDetailsGama>
          <div class="m-3">
            <Tables ref="tableGridDetalhesPrestacaoContasViagem"
                :columns= this.coluna
                :showReload="false"
                v-on:Load="onLoadFuncionario"
                :showButtonNew="true"
                @check="eventcheck"
                :showCheckInput="true "
                :newHeaderStatus="true"
                :showHeader="true"
                >
                <!-- <template #ButtonsAprova>
                  <div class="buttonaprova" v-if="hasRole(roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL)  || hasRole(roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL) && dataexpenses.every((Element) => Element.statusDespesa == 1) == true ">
                    <button type="btn-voltar" v-on:click="$router.back()" class="btn btn-third btn-sm" ><i class="fas fa-arrow-circle-left "></i></button>
                    <button class="btn-rep" @click="disaApprove" ><i class="fas fa-thumbs-down"></i> Reprovar</button>
                    <button class="btn-appr" @click="approve"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                  </div>
                  <div class="buttonaprova"  v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) && dataexpenses.every((Element) => Element.statusDespesa == 2) == true || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL) && dataexpenses.every((Element) => Element.statusDespesa == 2) == true">
                    <button type="btn-voltar" v-on:click="$router.back()" class="btn btn-third btn-sm" ><i class="fas fa-arrow-circle-left "></i></button>
                    <button class="btn-rep" @click="disaApprove" ><i class="fas fa-thumbs-down"></i> Reprovar</button>
                    <button class="btn-appr" @click="approve"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                  </div>
                  <div v-else-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
                    <button type="btn-voltar" v-on:click="$router.back()" class="btn btn-third btn-sm" ><i class="fas fa-arrow-circle-left "></i></button>
                  </div>
                </template> -->
                <tr v-for="data in dataexpenses" :key="data.id">
                    <TableColumn :IsCustomButtons="true"><input :id="data.id" type="checkbox" class="w-100"></TableColumn>
                    <TableColumn :IsTextGreeen="data.preAprovada == 'Sim'" :status="1" :value="data.preAprovada" v-if="ehCoordenadorViagem || ehTecnicoViagem" />
                    <TableColumn :IsText="true"   :status="1" :value="data.dataRegistroDespesaFormatada" />
                    <TableColumn :IsTextOrange="data.statusDespesa == 9" :IsTextYellow="data.statusDespesa == 1" :IsTextGreen="data.statusDespesa == 2" :IsTextBlue="data.statusDespesa == 3" :status="1" v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)" :value="data.statusDespesa != null ? (data.statusDespesa == 9 ? 'AG. APROVAÇÃO TÉCNICO' : data.statusDespesa == 1 ? 'AG. APROVAÇÃO COORDENADOR' : data.statusDespesa == 2 ? 'AG. APROVAÇÃO TRANSPORTE' : data.statusDespesa == 3 ? 'AG. APROVAÇÃO DIRETORIA' : 'N/D') : 'N/D'" />
                    <TableColumn :IsText="true"   :status="1" :value="data.categoriaDescricao" />
                    <TableColumn :IsText="true"   :status="1" :value="data.subCategoria == null ? data.subCategoriaVeiculoDescricao : data.subCategoriaDescricao" />
                    <TableColumn :IsText="true"   :status="1" :value="data.quantidade" />
                    <TableColumn :IsText="true"   :status="1" :value="formatMoney(data.valor)"/>
                    <TableColumn
                        :newEditGama="true"
                        :HasChange="true"
                        :IsViewExpenses="true"
                        v-on:Edit="$emit('onSelect',data)"
                        v-on:DetailsExpense="openPopup(data)"></TableColumn>
                </tr>
                <tr>
                    <td colspan="6"></td>
                    <td class="text-center total-table">TOTAL: {{ formatMoney(totalTable)}}</td>
                </tr>
                <b-modal ref="openModalDetail"
                size="lg"
                id="open-modal-despesa"
                  title="COMPROVANTE"
                  centered
                  :clickToClose="false"
                  :no-close-on-backdrop="true"
                  :no-close-on-esc="true"
                  :hide-footer="true"
                  body-class="p-0"
                  hide-header-close>
                  <template #modal-title="{ close }">
                  <div class="header w-100">
                    <div class="titulo-modal">COMPROVANTE ( {{ posicaoSelecionada + 1 }} / {{ dataexpenses.length }} )</div>
                    <div class="button-modal d-flex">
                      <div class="btn-header">
                        <div class="btn-repappr">
                          <div class="btn-appr-rep mr-3" v-if="(hasRole(roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL)) && detalheDespesa.statusDespesa == 1">
                            <button class="btn-rep-popup mr-3" @click="DisaApprovedDespesaByid" ><i class="fas fa-thumbs-down"></i> Reprovar</button>
                            <button class="btn-appr-popup" v-if="ehCoordenadorViagem || (!ehCoordenadorViagem && !ehTecnicoViagem)" @click="ApprovedDespesaByid"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                            <button class="btn-appr-popup" v-if="mostrarPreAprovarViagem && ehTecnicoViagem" @click="PreApprovedDespesaByid"><i class="fas fa-thumbs-up"></i> Pré-aprovar</button>
                          </div>
                          <div class="btn-appr-rep mr-3" v-if="hasRole(roles.ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL) && detalheDespesa.statusDespesa == 9">
                            <button class="btn-rep-popup mr-3" @click="DisaApprovedDespesaByid" ><i class="fas fa-thumbs-down"></i> Reprovar</button>
                            <button class="btn-appr-popup mr-3" v-if="mostrarPreAprovarViagem && ehTecnicoViagem" @click="PreApprovedDespesaByid"><i class="fas fa-thumbs-up"></i> Pré-aprovar</button>
                            <button class="btn-appr-popup" @click="abrirModalTecnico"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                          </div>
                          <div class="btn-appr-rep" v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) && detalheDespesa.statusDespesa == 2|| hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL) && detalheDespesa.statusDespesa == 2">
                            <button class="btn-rep-popup mr-3" @click="DisaApprovedDespesaByid" ><i class="fas fa-thumbs-down"></i> Reprovar</button>
                            <button class="btn-appr-popup" @click="ApprovedDespesaByid"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                          </div>
                        </div>
                      </div>
                      <div class="ml-3 mr-3 closepoup" @click="close()"><i class="fa fa-times"></i></div>
                    </div>
                  </div>
                </template>
                  <!-- <div class="header">
                    <div class="header-title">
                      COMPROVANTE ( {{ posicaoSelecionada + 1 }} / {{ dataexpenses.length }} )
                    </div>
                      <div class="btn-header"  v-if="hasRole(roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL)">
                        <div class="btn-repappr">
                          <button class="btn-rep-popup" @click="DisaApprovedDespesaByid" ><i class="fas fa-thumbs-down"></i> Reprovar</button>
                          <button class="btn-appr-popup" @click="ApprovedDespesaByid"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                        </div>
                      </div>
                      <div class="btn-header"  v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) && detalheDespesa.statusDespesa == 2|| hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL) && detalheDespesa.statusDespesa == 2">
                        <div class="btn-repappr">
                          <button class="btn-rep-popup" @click="DisaApprovedDespesaByid" ><i class="fas fa-thumbs-down"></i> Reprovar</button>
                          <button class="btn-appr-popup" @click="ApprovedDespesaByid"><i class="fas fa-thumbs-up"></i> Aprovar</button>
                        </div>
                      </div>
                      <div class="fa fa-times closePopup" @click="closePopup"></div>
                  </div> -->
                    <div class="ml-2 mr-2">
                      <div class="descricao-despesa">
                        <div class="d-flex descricao">
                          <div class="d-flex w-100">
                            <div class="col-md-3">
                              <label>Data da Despesas</label>
                              <div class="label-details-despesas">{{ detalheDespesa.dataRegistroDespesaFormatada }}</div>
                            </div>
                            <div class="col-md-3">
                              <label>Valor</label>
                              <div class="label-details-despesas">{{ formatMoney(detalheDespesa.valor) }}</div>
                            </div>
                            <div class="col-md-3">
                              <label>Categoria</label>
                              <div class="label-details-despesas">{{detalheDespesa.categoriaDescricao}}</div>
                            </div>
                            <div class="col-md-3">
                              <label>SubCategoria</label>
                              <div class="label-details-despesas">{{detalheDespesa.subCategoriaDescricao}}</div>
                            </div>
                          </div>
                        </div>
                        <div class="comprovante-container">
                          <div>
                            <div v-if="this.isExcel && !this.isPdf" class=" download-comprovante-excel" @click="downloadComprovante()"><i class="fas fa-download"></i>
                            </div>
                            <i v-if="this.isExcel && !this.isPdf" class="arquivo-excel fas fa-file-excel mr-1 fa-5x"></i>
                            <div class="comprovante-footer" v-if="this.isExcel && !this.isPdf">
                              {{ arquivodespesaid.data != null ? arquivodespesaid.data.arquivo != null ? arquivodespesaid.data.arquivo.name : "N/D" : "N/D" }}
                            </div>
                          </div>
                          <div v-if="base64 === false && midiapdf == null">
                            <div class="icone-texto-header error-header">
                              <i class="fas fa-exclamation-triangle icone-error"></i>
                            </div>
                            <div class="icone-texto-header texto-error">
                              Erro no comprovante da despesa
                            </div>
                          </div>
                          <div v-else>
                            <div class="img-container"  v-if="!this.isPdf && !this.isExcel && midiapdf != null">
                              <img
                              v-if="!this.isPdf && !this.isExcel"
                              style="overflow: hidden"
                              class="pdf-overview"
                              @click="openDetailsimg"
                              :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf ">
                              <div class="comprovante-footer">
                                {{ arquivodespesaid.data != null ? arquivodespesaid.data.arquivo != null ? arquivodespesaid.data.arquivo.name : "N/D" : "N/D" }}
                              </div>
                            </div>
                          </div>
                              <div class="comprovante-container"  v-if="midiapdf != null">
                              <object class="img-container" v-if="this.isPdf && !this.isExcel">
                                <!-- <embed type="text/html"  width="100%" height="1000"  :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf"/> -->
                                <div class="d-flex flex-column">
                                  <!-- <div class="fas fa-search fa-3x" @click="openDetailsimg"></div> -->
                                    <iframe
                                      style="overflow: hidden; height: 50vh;"
                                      frameborder="0"
                                      scrolling="no"
                                      id="pdfViewer"
                                      width="100%"
                                      :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf">
                                    </iframe>
                                    <div class="comprovante-footer" v-if="this.isPdf && !this.isExcel" @click="openDetailsimg">
                                      <i class="fas fa-search" ></i>
                                      {{ arquivodespesaid.data != null ? arquivodespesaid.data.arquivo != null ? arquivodespesaid.data.arquivo.name : "N/D" : "N/D" }}
                                    </div>
                                </div>
                              </object>
                            </div>
                        </div>
                    </div>
                    </div>
                  </b-modal>
                <b-modal ref="Detailsimg" hide-footer hide-header size="xl">
                  <div class="fa fa-times closePopup" @click="closeDetailsimg"></div>
                  <div class="popup-detcomprovante">
                    <img
                            v-if="!this.isPdf && !this.isExcel"
                            style="overflow: hidden"
                            class="pdf-overview"
                            @click="openDetailsimg"
                            :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf ">
                    <!-- <embed type="text/html" height="200%" width="" :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf" /> -->
                    <iframe
                    v-if="this.isPdf && !this.isExcel"
                    centered
                    allowfullscreen
                    id="pdfViewer"
                    tyle="overflow: hidden"
                    frameborder="0"
                    scrolling="no"
                    width="100%"
                    height="100%"
                    :src="`${this.isPdf ? `data:application/${type}` : `data:image/${type}`};base64,`+ midiapdf">
                  </iframe>
                  <div class="download-comprovante" @click="downloadComprovante()"><i class="fas fa-download"></i></div>
                </div>
                </b-modal>
            </Tables>
          </div>
      </div>
      <RefuseModalReturnTrip :modalReturn="modalReturn" :lstdespesa="lstdespesa" @Load="Load" :viagemMetodo="viagemMetodo" :viagemMetodoUnico="viagemMetodoUnico" :detalheDespesa="detalheDespesa.id"></RefuseModalReturnTrip>
      <b-modal ref="modalAprovarTecnico" hide-footer centered title="Aprovar — Escolha o Coordenador" size="md">
        <addTecnicoViagem
          :despesasidEnviarCoordenador="despesaIdTecnico"
          :UnicaDespesa="unicaDespesaTecnico"
          @fecharEnviarCoordenador="fecharModalTecnico"
          @fechaModalAprovacaoEnvioCoordenador="onAprovouTecnico"
          @onloadReacarregar="onAprovouTecnico"></addTecnicoViagem>
      </b-modal>
      <b-modal ref="modal-review-confirm"
          size="md"
          centered
          title="Confirmar Revisão"
          :hide-footer="true"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true">
        <div class="review-modal-icon">
          <i class="fas fa-undo-alt"></i>
        </div>
        <div class="review-modal-label">
          Confirma o retorno das despesas selecionadas para Transportes?
        </div>
        <div v-if="hasRole(roles.RW_REAL_ESTA_ADMIN)" class="review-modal-warning">
          Atenção: como perfil Administrativo, despesas que já estiverem vinculadas a um lote serão removidas do lote.
        </div>
        <div class="review-modal-actions">
          <button @click="closeReviewModal" class="review-btn-cancel">CANCELAR</button>
          <button @click="confirmReview" class="review-btn-confirm">CONFIRMAR</button>
        </div>
      </b-modal>
    </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import MidiaExpense from '@/shared/http/repositories/business/midiaexpense.js'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import RefuseModalReturnTrip from '@/views/private/finance/expenses/trevelexpenseemployee/components/RefuseModalReturnTrip/RefuseModalReturnTrip.vue'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import addTecnicoViagem from '@/views/private/finance/expenses/trevelexpenseemployee/components/addTecnicoViagem/addTecnicoViagem.vue'
export default {
  name: 'Table',
  mixins: [ActionsForm],
  components: {HeadDetailsGama, RefuseModalReturnTrip, addTecnicoViagem},
  props: ['dataExpenseDetails'],
  data () {
    return {
      viagemMetodo: null,
      viagemMetodoUnico: null,
      lstdespesa: [],
      coluna: [],
      modalReturn: false,
      dataexpenses: [],
      funcionarioid: null,
      dataFormSearch: localStoreHelper.viagem.prestacaoContasDetalhes() || {},
      detalheDespesa: {},
      midiapdf: null,
      isPdf: false,
      isExcel: false,
      despesaviagemid: null,
      despesaid: null,
      arquivodespesaid: {},
      base64: null,
      imagePath: null,
      type: null,
      formatoArquivo: 0,
      nomeArquivo: null,
      arquivoFormato: '',
      tipo: null,
      posicaoSelecionada: null,
      totalTable: 0.0,
      usuarioGrupoDV: {},
      despesaIdTecnico: null,
      unicaDespesaTecnico: true,
      // Pré-aprovar oculto em todas as telas de Despesa de Viagem ATÉ SEGUNDA ORDEM. Virar true pra reativar.
      mostrarPreAprovarViagem: false
    }
  },
  computed: {
    podeAprovarEtapa: function () {
      let admin = this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)
      let coord = this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL)
      let transp = admin || this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)
      // ADMIN aprova em qualquer etapa: coordenador(1) e transporte(2). Etapa 9 e 3 tem botao proprio.
      // someStatus (nao allStatus): status misto (ex: tecnico+coordenador com despesas em 9 e 1) nao
      // trava mais o botao de lote. approve() filtra os checados pela etapa permitida antes de enviar.
      return ((coord || admin) && this.someStatus(1)) || (transp && this.someStatus(2))
    },
    // Quem e o que = PERFIL (role). Substitui a fonte legada (usuariogrupodespesaviagem), fora do escopo.
    ehTecnicoViagem: function () {
      return this.hasRole(this.roles.ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)
    },
    ehCoordenadorViagem: function () {
      return this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL)
    },
    titleModal: function () {
      let result = 'VISUALIZAÇÃO DE ANXO'
      if (this.arquivodespesaid.data.arquivo) {
        result = 'VISUALIZAÇÃO DE ANXO - ' + this.arquivodespesaid.data.arquivo.name
      }
      return result
    },
    verificarcontraladoria: function () {
      if (this.dataFormSearch === undefined) return true
      if (this.dataFormSearch.situacao === null || this.dataFormSearch.situacao === undefined) return true
      return parseInt(this.dataFormSearch.situacao) === 1
    },
    showImage: function () {
      let result = ''
      if (this.imagePath) {
        result = this.imagePath
      }
      return result
    }
  },
  mounted () {
    let param = new URLSearchParams(window.location.search)
    this.funcionarioid = param.get('funcionario')
    if (param.get('funcionario') == null) this.$router.push('/despesa/viagem')
    this.onLoadFuncionario()
    this.despesaviagemid = this.dataExpenseDetails
    // this.colunaVerifica()
  },
  methods: {
    allStatus (n) {
      return this.dataexpenses.length > 0 && this.dataexpenses.every((e) => e.statusDespesa === n)
    },
    someStatus (n) {
      return this.dataexpenses.length > 0 && this.dataexpenses.some((e) => e.statusDespesa === n)
    },
    colunaVerifica () {
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        this.coluna = ['Data das Despesas', 'Situação', 'Categoria', 'Subcategoria', 'Quantidade', 'Valor', '']
      } else {
        if (this.ehCoordenadorViagem || this.ehTecnicoViagem) {
          this.coluna = ['Pré-aprovada', 'Data das Despesas', 'Categoria', 'Subcategoria', 'Quantidade', 'Valor', '']
        } else {
          this.coluna = ['Data das Despesas', 'Categoria', 'Subcategoria', 'Quantidade', 'Valor', '']
        }
      }
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    getchecked () {
      let arrayids = this.dataexpenses.map((Element) => Element.id)
      let lstapprove = []
      arrayids.forEach((Element) => {
        let input = document.getElementById(Element)
        if ((input !== undefined || input !== null) && input.checked === true) {
          lstapprove.push(Element)
        }
      })
      return lstapprove
    },
    Load () {
      let param = new URLSearchParams(window.location.search)
      this.funcionarioid = param.get('funcionario')
      if (param.get('funcionario') == null) this.$router.push('/despesa/viagem')
      this.onLoadFuncionario()
      this.$refs['openModalDetail'].hide()
    },
    onLoadFuncionario (data) {
      Object.assign(this.dataFormSearch, data)
      this.dataFormSearch.CompanyId = this.CompanySelected
      this.dataFormSearch.TipoPerfil = 1
      loading.push()
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        TravelExpenseRepository.GetAllByUsarioIdAdmin(this.funcionarioid, this.dataFormSearch, this.$refs.tableGridDetalhesPrestacaoContasViagem.pagingLimit, this.$refs.tableGridDetalhesPrestacaoContasViagem.pagingIndex)
          .then((Response) => {
            loading.pop()
            this.colunaVerifica()
            this.$emit('setdespesasexpense', Response.data.data)
            this.dataexpenses = Response.data.data
            this.$refs.tableGridDetalhesPrestacaoContasViagem.LoadAllByData(Response)
            this.sumValor(this.dataexpenses)
          })
      } else if (this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        this.colunaVerifica()
        TravelExpenseRepository.GetAllByUsarioId(this.funcionarioid, this.dataFormSearch, this.$refs.tableGridDetalhesPrestacaoContasViagem.pagingLimit, this.$refs.tableGridDetalhesPrestacaoContasViagem.pagingIndex)
          .then((Response) => {
            loading.pop()
            this.$emit('setdespesasexpense', Response.data.data)
            this.dataexpenses = Response.data.data
            this.$refs.tableGridDetalhesPrestacaoContasViagem.LoadAllByData(Response)
            this.sumValor(this.dataexpenses)
          })
      }
    },
    eventcheck (e) {
      let arrayids = this.dataexpenses.map((Element) => Element.id)
      arrayids.forEach((Element) => {
        let input = document.getElementById(Element)
        if (input !== undefined || input !== null) input.checked = e.checked
      })
    },
    disaApprove () {
      let lstapprove = this.getchecked()
      if (lstapprove.length > 0) {
        this.lstdespesa = this.getchecked()
        this.viagemMetodoUnico = null
        this.modalReturn = !this.modalReturn
        this.viagemMetodo = this.viagemMetodo === 0 ? 1 : 0
      } else {
        toast.warning('Selecione uma despesa!')
      }
    },
    approve () {
      let checkedIds = this.getchecked()
      if (checkedIds.length === 0) {
        toast.warning('Selecione uma despesa!')
        return
      }
      // So envia pro lote as despesas na etapa que ESTE usuario pode aprovar (coordenador->1, transporte->2,
      // admin->1 e 2). Evita que um item de etapa errada (ex: status 9 num lote misto) seja empurrado pro
      // ApproveDespesasViagemContraladoria, cujo ternario pularia direto pra DIRETORIA.
      let admin = this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)
      let coord = this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL)
      let transp = this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)
      let etapasPermitidas = []
      if (coord || admin) etapasPermitidas.push(1)
      if (transp || admin) etapasPermitidas.push(2)
      let lstapprove = this.dataexpenses
        .filter((e) => checkedIds.indexOf(e.id) !== -1 && etapasPermitidas.indexOf(e.statusDespesa) !== -1)
        .map((e) => e.id)
      if (lstapprove.length === 0) {
        toast.warning('Selecione despesas na sua etapa de aprovação!')
        return
      }
      loading.push()
      TravelExpenseRepository.ApproveDespesasViagemContraladoria(lstapprove)
        .then((Response) => {
          loading.pop()
          if (Response.data) this.onLoadFuncionario()
          toast.success('Despesas Aprovadas com sucesso')
        })
        .catch((Error) => {
          loading.pop()
          toast.error('Não foi possível aprovar as despesas')
        })
    },
    openReviewModal () {
      let checkedIds = this.getchecked()
      if (checkedIds.length === 0) {
        toast.warning('Selecione uma despesa!')
        return
      }
      let elegiveis = this.dataexpenses.filter((e) => checkedIds.indexOf(e.id) !== -1 && e.statusDespesa === 3)
      if (elegiveis.length === 0) {
        toast.warning('Selecione despesas em AG APROVAÇÃO DIRETORIA!')
        return
      }
      this.$refs['modal-review-confirm'].show()
    },
    closeReviewModal () {
      this.$refs['modal-review-confirm'].hide()
    },
    confirmReview () {
      let checkedIds = this.getchecked()
      let lstreview = this.dataexpenses.filter((e) => checkedIds.indexOf(e.id) !== -1 && e.statusDespesa === 3).map((e) => e.id)
      if (lstreview.length === 0) {
        toast.warning('Selecione despesas em AG APROVAÇÃO DIRETORIA!')
        this.closeReviewModal()
        return
      }
      loading.push()
      TravelExpenseRepository.ReviewExpensesByDirectory({ despesasIds: lstreview })
        .then((Response) => {
          loading.pop()
          this.closeReviewModal()
          let r = Response.data || {}
          let revisadas = (r.revisadas || []).length
          let removidasDoLote = (r.removidasDoLote || []).length
          let ignoradasComLote = (r.ignoradasComLote || []).length
          let ignoradasStatusInvalido = (r.ignoradasStatusInvalido || []).length

          if (revisadas > 0) {
            let msg = revisadas + ' despesa(s) retornada(s) para Controladoria/Transportes'
            if (removidasDoLote > 0) msg += ' — ' + removidasDoLote + ' removida(s) do lote'
            toast.success(msg)
          }
          if (ignoradasComLote > 0) {
            toast.warning(ignoradasComLote + ' despesa(s) ignorada(s): já estão em lote gerado')
          }
          if (ignoradasStatusInvalido > 0) {
            toast.warning(ignoradasStatusInvalido + ' despesa(s) ignorada(s): status diferente de AG APROVAÇÃO DIRETORIA')
          }
          if (revisadas === 0 && ignoradasComLote === 0 && ignoradasStatusInvalido === 0) {
            toast.warning('Nenhuma despesa retornada')
          }
          // Volta pra grid principal já filtrada por AG APROVAÇÃO DIRETORIA
          if (revisadas > 0) {
            localStoreHelper.viagem.prestacaoContas({ Situacao: 3 })
            this.$router.push('/despesa/viagem')
          } else {
            this.onLoadFuncionario()
          }
        })
        .catch((Error) => {
          loading.pop()
          this.closeReviewModal()
          toast.error('Erro ao retornar despesas')
        })
    },
    verificaPos () {
      this.posicaoSelecionada = this.dataexpenses.indexOf(this.detalheDespesa)
    },
    openPopup (Response) {
      this.midiapdf = null
      this.base64 = true
      this.detalheDespesa = Response
      this.despesaid = Response.id
      this.getcomprovantebyfuncionarioid(this.despesaid)
      this.verificaPos()
      this.$refs['openModalDetail'].show(Response)
    },
    closePopup () {
      this.$refs['openModalDetail'].hide()
      this.detalheDespesa = {}
    },
    showpdf () {
      this.$refs['modal-showpdf'].show()
      this.loadImage(this.arquivodespesaid)
    },
    ApprovedDespesaByid () {
      loading.push()
      TravelExpenseRepository.ApprovedDespesaByid(this.detalheDespesa.id)
        .then((Response) => {
          toast.success('Despesa Aprovada com sucesso')
          this.dataexpenses = []
          this.detalheDespesa = {}
          loading.pop()
          this.NextpopUp()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning((Error && Error.response && Error.response.data) ? Error.response.data : 'Não foi possível aprovar a despesa')
        })
      TravelExpenseRepository.GetAllByUsarioId(this.funcionarioid, this.dataFormSearch, this.$refs.tableGridDetalhesPrestacaoContasViagem.pagingLimit, this.$refs.tableGridDetalhesPrestacaoContasViagem.pagingIndex)
        .then((Response) => {
          if (Response.data.data.length === 0) {
            this.onLoadFuncionario()
          } else {
            this.dataexpenses = Response.data.data
            this.openPopup(this.dataexpenses[0])
          }
        })
    },
    abrirModalTecnico () {
      this.unicaDespesaTecnico = true
      this.despesaIdTecnico = this.detalheDespesa.id
      this.$refs['modalAprovarTecnico'].show()
    },
    abrirModalTecnicoLote () {
      let checked = this.getchecked()
      if (checked.length === 0) {
        toast.warning('Selecione uma despesa!')
        return
      }
      this.unicaDespesaTecnico = false
      this.despesaIdTecnico = checked
      this.$refs['modalAprovarTecnico'].show()
    },
    fecharModalTecnico () {
      this.$refs['modalAprovarTecnico'].hide()
    },
    onAprovouTecnico () {
      this.$refs['modalAprovarTecnico'].hide()
      this.$refs['openModalDetail'].hide()
      this.dataexpenses = []
      this.detalheDespesa = {}
      this.onLoadFuncionario()
    },
    PreApprovedDespesaByid () {
      loading.push()
      TravelExpenseRepository.PreApprovedDespesaByid(this.detalheDespesa.id)
        .then((Response) => {
          toast.success('Despesa Pré-aprovada com sucesso')
          this.dataexpenses = []
          this.detalheDespesa = {}
          loading.pop()
          this.NextpopUp()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning((Error && Error.response && Error.response.data) ? Error.response.data : 'Não foi possível aprovar a despesa')
        })
      TravelExpenseRepository.GetAllByUsarioId(this.funcionarioid, this.dataFormSearch, this.$refs.tableGridDetalhesPrestacaoContasViagem.pagingLimit, this.$refs.tableGridDetalhesPrestacaoContasViagem.pagingIndex)
        .then((Response) => {
          if (Response.data.data.length === 0) {
            this.onLoadFuncionario()
          } else {
            this.dataexpenses = Response.data.data
            this.openPopup(this.dataexpenses[0])
          }
        })
    },
    NextpopUp () {
      if (this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) {
        TravelExpenseRepository.GetAllByUsarioId(this.funcionarioid, this.dataFormSearch)
          .then((Response) => {
            if (Response.data.data.length === 0) {
              this.onLoadFuncionario()
            } else {
              this.dataexpenses = Response.data.data
              this.openPopup(this.dataexpenses[0])
            }
          })
      }
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        TravelExpenseRepository.GetAllByUsarioIdAdmin(this.funcionarioid, this.dataFormSearch)
          .then((Response) => {
            if (Response.data.data.length === 0) {
              this.onLoadFuncionario()
            } else {
              this.dataexpenses = Response.data.data
              this.openPopup(this.dataexpenses[0])
            }
          })
      }
    },
    DisaApprovedDespesaByid () {
      this.modalReturn = !this.modalReturn
      this.viagemMetodo = null
      this.lstdespesa = this.getchecked()
      this.viagemMetodoUnico = this.viagemMetodo === 0 ? 1 : 0
      // loading.push()
      // TravelExpenseRepository.DisaApprovedDespesaByid(this.detalheDespesa.id)
      //   .then((Response) => {
      //     toast.success('Despesa Reprovada com sucesso')
      //     this.dataexpenses = []
      //     this.closePopup()
      //     loading.pop()
      //   })
      //   .catch((Error) => {
      //     loading.pop()
      //     toast.warning(Error)
      //   })
      // TravelExpenseRepository.GetAllByUsarioId(this.funcionarioid, this.dataFormSearch)
      //   .then((Response) => {
      //     if (Response.data.data.length === 0) {
      //       this.onLoadFuncionario()
      //     } else {
      //       this.dataexpenses = Response.data.data
      //       this.openPopup(this.dataexpenses[0])
      //     }
      //   })
    },
    getcomprovantebyfuncionarioid () {
      MidiaExpense.GetByDespesaId(this.despesaid)
        .then(Response => {
          this.arquivodespesaid = Response
          this.nomeArquivo = Response.data.arquivo.name
          this.arquivoFormato = this.nomeArquivo.replace(/^.*\./, '')
          this.loadImage()
        })
        .catch((Error) => {
          toast.error('Erro ao fazer Download')
          loading.close()
        })
    },
    // getarquivo64 () {
    //   loading.push()
    //   TravelExpenseRepository.Download(this.arquivodespesaid.data.arquivoID, this.CompanySelected)
    //     .then(Response => {
    //       if (Response.data) {
    //         this.base64 = Response.data
    //         loading.pop()
    //         if (this.base64 === 'null') {
    //           this.base64 = false
    //         }
    //       } else {
    //         loading.pop()
    //       }
    //     })
    //     .catch((Error) => {
    //       toast.error(Error)
    //       loading.close()
    //     })
    // },
    loadImage () {
      loading.push()
      let midiaName = this.arquivodespesaid.data.arquivo.name
      this.type = this.arquivodespesaid.data.arquivo.name.split('.').pop()
      this.isPdf = midiaName.toLowerCase().includes('pdf')
      this.isExcel = midiaName.toLowerCase().includes('xlsx')
      TravelExpenseRepository.Download(this.arquivodespesaid.data.arquivo.id, this.CompanySelected).then((e) => {
        this.midiapdf = e.data
        if (this.midiapdf == null) {
          this.base64 = false
        }
      }).catch(() => {
        this.base64 = false
        toast.error('Não foi possivel carregar o comprovante')
        loading.pop()
      })
        .finally(() => { loading.pop() })
    },
    openDetailsimg () {
      this.$refs['Detailsimg'].show()
    },
    closeDetailsimg () {
      this.$refs['Detailsimg'].hide()
    },
    downloadComprovante () {
      if (this.base64 != null) {
        var a = document.createElement('a')
        const typefile = 'v,slv'.includes('.pdf') ? 'application/pdf' : 'image/png'
        a.href = `data:${typefile};base64,` + this.base64
        a.download = this.nomeArquivo
        a.click()
        toast.success('Sucesso ao fazer o Donwload')
      } else {
        toast.warning('Erro ao fazer Download')
      }
    },
    sumValor () {
      let valorDespesa = this.dataexpenses
      let total = 0
      let totalDespesas = valorDespesa.map((element) => element.valor)
      totalDespesas.forEach((element) => {
        total = total + element
      })
      this.totalTable = total
    }
  }
}
</script>

<style scoped>
.reprova-aprova{
  display: flex;
  justify-content: right;
}
.margem{
  margin: 0.5rem;
}
.details-body{
    height: fit-content;
    overflow: auto;
    background: white;
    border: 1px solid rgb(211, 210, 210);
    border-radius: 6px
}

h5.modal-header{
  width:100%;
}

h5.modal-title{
  width:100% !important;
}
.button-modal {
  position: absolute;
    align-items: center;
    right: 0px;
}
.closepoup{
  cursor: pointer;
}
.icone-texto-header{
  display: flex;
  justify-content: center;
}
.error-header {
  margin: 3rem 0 1rem 0;
}
.texto-error {
  font-size: 15px;
  color: #008144;
}
.icone-error{
  font-size: 60px;
}
.modal-body {
  background-color: red !important;
}
.pdf-overview {
    width: 100%;
    height: 100%;
}
.quadro {
    position: absolute;
    z-index: 1000;
    width: 580px;
    height: 154px;
    top: 35px;
}
.btn-voltar {
  height: 2rem;
}
 .buttonaprova{
    height: 2.5rem;
    display: flex;
    width: 100%;
    gap: 10px;
    align-items: center;
  }
.btn-rep{
    width: 10vw;
    background: red;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    height: 2rem;
  }
.btn-appr{
    width: 10vw;
    height: 2rem;
    background: #008144;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
}
.btn-rep-popup{
    width: 10vw;
    background: red;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    height: 2rem;
    font-size: 14px;
  }
.btn-appr-popup{
    width: 10vw;
    height: 2rem;
    background: #008144;;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    font-size:14px
}
.descricao-despesa{
  width: 100%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  padding: 1rem;
}
.descricao{
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
}
.detail{
  gap:1rem;
  display: flex;
  justify-content: space-around;
}
.label-details-despesas{
    font-size: 14px;
    font-weight: bold;
    word-break: break-all;
}
.btn-appr-rep {
  display: flex;
  justify-content: space-around;
}
.pdf-icon-container{
  width: 100%;
  height: 100%;
  display:flex;
  justify-content: center;
  align-items: center;
}
.edit-file{
    height: 25px;
    width: 40px;
    color: white;
    font-size: 12px;
    cursor: pointer;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0px;
    background: #008144;
  }
  .footer-file{
    height: 30px;
    width: 100%;
    color: rgb(163, 163, 163);
    border-radius: 0px 0px 10px 10px;
    background: #eceff1;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }

  .subtitle {
    font-size: 16px;
    font-weight: bold;
    color: #008144;
  }
  .image-comprovante{
    height: fit-content;
    width: 100% !important;
    object-fit: contain;
  }
.download-comprovante{
    height: 30px;
    position: absolute;
    top: 40px;
    display: flex;
    align-items: center;
    right: 0px;
    justify-content: center;
    color: white;
    cursor: pointer;
    width: 40px;
    background: #008144;
    border-radius: 3px 0px 0px 3px;
  }
  .comprovante-footer{
    width: 100%;
    height: fit-content;
    padding: 10px;
    font-weight: bold;
    background: rgb(216, 216, 216);
    bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: gray;
    border-radius: 0px 0px 10px 10px;
  }
  .arquivo-excel{
    display: flex;
    justify-content: center;
    margin: 1rem;
  }
  .popup-detcomprovante{
    height: 85vh;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .download-comprovante-excel {
    height: 30px;
    position: relative;
    display: flex;
    align-items: center;
    left: 85%;
    justify-content: center;
    color: white;
    cursor: pointer;
    width: 40px;
    background: #008144;;
    border-radius: 3px 0px 0px 3px;
  }
  .closePopup {
    display: flex;
    flex-direction: row-reverse;
  }
  .header {
    display: flex;
    flex-wrap: wrap;
    color: white;
    justify-content: space-between;
    align-items: center;
    width:100%;
  }
  .header-title {
    font-size: 20px;
    font-weight: bold;
  }
  .btn-header {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
  .btn-repappr{
    gap: 1rem;
  }
  .custom-modal .modal-dialog {
    border-radius: 10px; /* Adjust the value as per your requirement */
  }
  .total-table{
    border: 1px solid rgb(219, 219, 219);
    color: #025e33;
    font-weight: bold;
  }
  .btn-revise{
    width: 10vw;
    background: #ffa726;
    color: white;
    margin-left: 5px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
  .btn-revise:hover{
    background: #fb8c00;
  }
  .review-modal-icon{
    display: flex;
    font-size: 44px;
    padding: 10px;
    justify-content: center;
    color: #ffa726;
  }
  .review-modal-label{
    padding: 0.5rem 1rem;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }
  .review-modal-warning{
    padding: 0.5rem 1rem;
    margin-top: 0.5rem;
    font-size: 13px;
    color: #b25500;
    background-color: #fff3e0;
    border-left: 4px solid #ffa726;
    border-radius: 4px;
  }
  .review-modal-actions{
    display: flex;
    gap: 1rem;
    justify-content: center;
    padding-top: 1.5rem;
  }
  .review-btn-cancel{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: rgb(167, 30, 30);
  }
  .review-btn-confirm{
    border-radius: 8px;
    border: transparent;
    height: 2.5rem;
    width: 8rem;
    color: white;
    background-color: #008144;
  }
  .review-btn-confirm:hover{
    background-color: #024d2a;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/trevelexpenseemployee/components/table/table.vue